import { useRef, useEffect } from 'react';
import { StoreFiltersDataLayer } from '@grandvisionhq/fun-store-filters';

const useNoStoresResultsEvent = (filteredResults)=>{
    const eventTriggeredRef = useRef(false);
    useEffect(()=>{
        if ((filteredResults === null || filteredResults === void 0 ? void 0 : filteredResults.results.length) === 0 && !eventTriggeredRef.current) {
            StoreFiltersDataLayer.pushStoreFiltersEvent({
                eventName: 'store_filters_click',
                interactionType: 'no_stores_match_warning'
            });
            eventTriggeredRef.current = true;
        }
        if ((filteredResults === null || filteredResults === void 0 ? void 0 : filteredResults.results.length) && (filteredResults === null || filteredResults === void 0 ? void 0 : filteredResults.results.length) > 0) {
            eventTriggeredRef.current = false;
        }
    }, [
        filteredResults === null || filteredResults === void 0 ? void 0 : filteredResults.results
    ]);
};

export { useNoStoresResultsEvent };
//# sourceMappingURL=use-no-stores-results-event.js.map
